import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { PdfLoadedEvent } from 'ngx-extended-pdf-viewer';
import { DialogComponent } from 'vcp-common-ui-lib';
import { PdfViewerComponent } from './pdf-viewer.component';

@Component({
    selector: 'vc-pdf-viewer-dialog',
    imports: [DialogComponent, PdfViewerComponent],
    templateUrl: './pdf-viewer-dialog.component.html',
    styleUrl: './pdf-viewer-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfViewerDialogComponent {
    readonly closeLabel = translate('COMMON_UI.BUTTON.CLOSE');

    @Input()
    title: string = '';

    @Input()
    width: string = 'calc(100vw - 48px)';

    @Input()
    height: string = 'calc(100vh - 48px)';

    @Input()
    src!: string | ArrayBuffer | Blob | Uint8Array | URL | undefined;

    @Input()
    set visible(value: boolean) {
        if (this._visible !== value) {
            this._visible = value;
            this.visibleChange.emit(this._visible);
        }
    }

    get visible(): boolean {
        return this._visible;
    }

    private _visible: boolean = false;

    @Input()
    loading: boolean = false;

    @Output()
    visibleChange = new EventEmitter<boolean>();

    @Output()
    pageChange = new EventEmitter<number>();

    @Output()
    pdfLoaded = new EventEmitter<PdfLoadedEvent>();

    @Output()
    pdfLoadingFailed = new EventEmitter<Error>();

    close(): void {
        this.visible = false;
    }
}
